import React from "react";
import { Grid } from "@material-ui/core";
import { Button, Datagrid, DateField, Labeled, TextField } from "react-admin";
import { deepRedirect } from "../../../utils/utils";
import { AddIcon, EditIcon } from "../../../components/common/iconography";
import { SortedArrayField } from "../../../components/common/SortedArrayField";

const ChecklistPanel = ({ disabled, ...props }) => {
  if (disabled) return <ChecklistShow {...props} />;
  return <ChecklistList {...props} />;
};

const ChecklistList = (props) => {
  const { record, history } = props;
  const backPath = [history.location.pathname + history.location.search];

  const handleCreate = () => {
    deepRedirect(history, `/checklists/create`, backPath, {
      resourceId: record.id,
    });
  };

  const rowClickHandler = (record) => {
    deepRedirect(history, `/checklists/${record.id}`, backPath);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Labeled label="Checklists" fullWidth>
          <SortedArrayField
            {...props}
            source="checklists.items"
            sort={{ field: "name", order: "ASC" }}
          >
            <Datagrid
              rowClick={(jsonRecord, basePath, record) =>
                rowClickHandler(record)
              }
            >
              <TextField source="name" />
              <TextField source="processName" label="Process Name" />
              <TextField source="active" />
              <DateField source="createdAt" label="Create Date" />
              <EditButton {...props} />
            </Datagrid>
          </SortedArrayField>
        </Labeled>
      </Grid>
      <Grid item xs={12}>
        <Button
          label="Add"
          color="default"
          onClick={handleCreate}
          disabled={record?.checklists?.items?.length === 10}
        >
          <AddIcon />
        </Button>
      </Grid>
    </Grid>
  );
};

const EditButton = (props) => {
  return (
    <Button
      label="Edit"
      size="small"
      color="primary"
      // onClick= rowClick handles redirect
    >
      <EditIcon />
    </Button>
  );
};

const ChecklistShow = (props) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Labeled label="Checklists" fullWidth>
          <SortedArrayField
            {...props}
            source="checklists.items"
            sort={{ field: "name", order: "ASC" }}
          >
            <Datagrid bulkActionButtons={false}>
              <TextField source="name" />
              <TextField source="processName" label="Process Name" />
              <DateField source="createdAt" label="Created At" />
            </Datagrid>
          </SortedArrayField>
        </Labeled>
      </Grid>
    </Grid>
  );
};

export default ChecklistPanel;
